import { TypeCall } from '@/types/common';
import { MANUAL_PARAMS_MAP, MANUAL_URL_MAP } from '@/utils/constants/chat';

/**
 * @desc 로그인 페이지로 이동하는 로직입니다.
 * @param lang
 * @param chatType -
 */
export default function redirectToManualPage(lang: 'ko' | 'en', chatType?: TypeCall) {
  if (!['ko', 'en'].includes(lang)) {
    return;
  }

  const url = MANUAL_URL_MAP[lang];
  const params = ['GENERAL', 'CONFERENCE', 'MEETING', 'AUDIENCE', 'SINGLE'].includes(chatType)
    ? `/sconchat/${MANUAL_PARAMS_MAP[chatType]}`
    : '';

  window.open(url + params, '_blank');
}
